// extracted by mini-css-extract-plugin
module.exports = {"header":"dashboard_header__19IQ1","dashboard":"dashboard_dashboard__31o9T"};